import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import FixtureInputModel from "../models/FixtureInputModel";
import FixtureInvoiceInputModel from "../models/FixtureInvoiceInputModel";
import FixtureModel from "../models/FixtureModel";
import FixtureQueryModel from "../models/FixtureQueryModel";

export interface SearchFixtureParam {
    pageSize: number,
    query: FixtureQueryModel
}

export interface GetFixtureByIdParam {
    id: string,
}

export interface DeleteParam {
    id: string,
}

export interface AddFixtureInvoiceParam {
    id: string,
}

export interface SplitFixtureParam {
    id: string,
}

export interface CorrectInvalidFixtureParam {
    id: string,
    charterer: string,
    FixtureType: number,
    loadPort: number,
    disport: number
}

export interface SetFixtureDoneParam {
    fixtureId: string,
    isDone: boolean
}

const FixtureApi = {
    Search(param: SearchFixtureParam) {
        return Api.post<SearchFixtureParam, BaseResponse<FixtureModel[]>>("/api/Fixture/Search", param);
    },
    GetMyFixtures() {
        return Api.get<unknown, BaseResponse<FixtureModel[]>>("/api/Fixture/GetMyFixtures", null);
    },
    Save(param: FixtureInputModel) {
        return Api.post<FixtureInputModel, BaseResponse<FixtureModel>>("/api/Fixture/Save", param);
    },
    SaveInvoice(param: FixtureInvoiceInputModel) {
        return Api.post<FixtureInvoiceInputModel, BaseResponse<FixtureModel>>("/api/Fixture/SaveInvoice", param);
    },
    GetById(param: GetFixtureByIdParam) {
        return Api.get<GetFixtureByIdParam, BaseResponse<FixtureModel>>("/api/Fixture/GetById", param);
    },
    AddFixtureInvoice(param: AddFixtureInvoiceParam) {
        return Api.post<AddFixtureInvoiceParam, BaseResponse<string>>("/api/Fixture/AddFixtureInvoice", param);
    },
    SplitFixture(param: SplitFixtureParam) {
        return Api.post<SplitFixtureParam, BaseResponse<string>>("/api/Fixture/SplitFixture", param);
    },
    Delete(param: DeleteParam) {
        return Api.post<DeleteParam, BaseResponse<FixtureModel[]>>("/api/Fixture/Delete", param);
    },
    AttachHandoverEmail(formData: FormData) {
        return Api.postForm<BaseResponse<string>>("/api/Fixture/AttachHandoverEmail", formData);
    },
    SetFixtureDone(param: SetFixtureDoneParam) {
        return Api.post<SetFixtureDoneParam, BaseResponse<string>>("/api/Fixture/SetFixtureDone", param);
    },
};
export default FixtureApi;